import * as m from '../jigsaw-methods';
import { createJigsawReaderAction } from '../jigsaw-action';

export const setRawZoom = createJigsawReaderAction(m.SET_ZOOM_SCALE);

/**
 * Actions that take no arguments and may be bound to click handlers
 * are pre-bound reject all args here so that you can't accidentally
 * pass in the click event object as a param
 */
export const zoomIn = () => createJigsawReaderAction(m.INCREASE_ZOOM)();
export const zoomOut = () => createJigsawReaderAction(m.DECREASE_ZOOM)();



// WEBPACK FOOTER //
// ./src/app/api/redux-jigsaw/zoom/actions.js